import React, { useRef, useState } from 'react';
import { Loader, Dimmer, TableBody, TableRow, TableCell } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import {
  formatMoneda,
  validaSoloNumero
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';
import useTable from '../useTable';

export const EstadosdeCuentaClientes = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const accbtnnentrega = JSON.parse(sessionStorage.getItem("accbtnnentregac"));
  const accbtnndebito = JSON.parse(sessionStorage.getItem("accbtnndebitoc"));


  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtFocus = useRef();

  const [inputalmacen, setInputalmacen] = useState(0);
  const [inputproducto, setInputproducto] = useState(0);
  const [client, setClient] = useState('');
  const [totaldeuda, setTotaldeuda] = useState(0.00);
  const [totalanticipos, setTotalanticipos] = useState(0.00);
  const [totalcredito, setTotalcredito] = useState(0.00);
  const [rifcliente, setRifcliente] = useState('');
  const [ordens, setOrdens] = useState('');
  const [disponiblec, setDisponiblec] = useState('');
  const [paracliente, setParacliente] = useState('');
  const [idclient, setIdclient] = useState('');
  const [idvendedr, setIdvendedr] = useState('');
  const [report, setReport] = useState('');
  const [status, setStatus] = useState(null);
  const [valalmacen, setValalmacen] = useState(null);
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [records, setRecords] = useState([]);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false
  });

  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

  let nomtabla;

  if (props.op === 3) {
    nomtabla = [
      { label: '', textAlign: 'center' },
      { label: 'N° DOCUMENTO', textAlign: 'center' },
      { label: 'DESCRIPCION', textAlign: 'center' },
      { label: 'FECHA', textAlign: 'center' },
      { label: 'MONTO', textAlign: 'center' },
      { label: 'ESTATUS', textAlign: 'center' },
    ];
  } else {
    nomtabla = [
      { label: '', textAlign: 'center' },
      { label: 'N° DOCUMENTO', textAlign: 'center' },
      { label: 'DESCRIPCION', textAlign: 'center' },
      { label: 'FECHA', textAlign: 'center' },
      { label: 'MONTO', textAlign: 'center' },
    ];
  }

  const headCells = nomtabla;

  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting
  } = useTable(records, headCells, filterFn);

  const handleSearch = e => {
    let target = e.target;

    setFilterFn({
      fn: items => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter(x => {
            if (formatMoneda(x.totalmonto.toString().replace(",", "").replace(".", ","), ",", ".", 2).includes(target.value) ||
              x.numfactura.toLowerCase().includes(target.value.toLowerCase())
              || x.descripcionnota !== null ? x.descripcionnota : ''.toLowerCase().includes(target.value.toLowerCase())

            ) {
              return x;
            }
          });
        }
      }
    })

  }



  const blanquear = () => {
    setActivate(false);
    setInputalmacen(0);
    setRifcliente('');
    setDisponiblec('');
    setParacliente('');
    setInputproducto(0);
    setStatus(null);
    setReport('');
    setIdclient('');
    setIdvendedr('');
    setValalmacen(0);
    setOrdens('');
    setClient('');
    setTotaldeuda(0.00);
    setTotalanticipos(0.00);
    setTotalcredito(0.00);
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();

  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.op === 1 || props.op === 2 || props.op === 3) {
      imprimirGeneral();
    }

  }


  const imprimirGeneral = () => {

    var reporte = "";
    let titulos = "";

    if (props.op === 1) {
      reporte = 'ReporteEstadoCeuntasyPorcobrar';
      titulos = 'ESTADOS DE CUENTA (DEUDAS)';
    } else if (props.op === 3) {
      reporte = 'ReporteEstadoCeuntasyPorcobrarTres';
      titulos = 'ESTADOS DE CUENTA (GENERAL)';
    } else {
      reporte = 'ReporteEstadoCeuntasyPorcobrarDos';
      titulos = 'ESTADOS DE CUENTA (PAGADAS)';
    }


    let condi = "'" + 'and n.status = ' + status + ' and n.idcliente = ' + idclient + "'";

    window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&condicion=" + condi + "&titulo=" + titulos, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
  }

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });

  };

  const cerrarModal = () => {
    if (props.llamado === 2) {
      props.onHideCancelar();
    }
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const seleccionarTotalesClientesPagosDetalle = (status, cliente) => {

    let endpoint = `${op.conexion}/api/agente/totalespagosdetalles?estatus=${status}&cliente=${cliente}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {

          setRecords(response.data);
          setClient(response.data[0].cliente);
          setRifcliente(response.data[0].rifclient);

          let total = 0.00;
          let toanticipo = response.data[0].totalanticipos !== null ? response.data[0].totalanticipos : 0.00;
          let tocredito = response.data[0].totalcredito !== null ? response.data[0].totalcredito : 0.00;

          for (let i = 0; i < response.data.length; i++) {

            total = parseFloat(total) + parseFloat(response.data[i].totalmonto);

          }
          setTotalanticipos(formatMoneda(toanticipo.toString().replace(",", "").replace(".", ","), ",", ".", 2));
          setTotalcredito(formatMoneda(tocredito.toString().replace(",", "").replace(".", ","), ",", ".", 2));
          setTotaldeuda(formatMoneda(total.toString().replace(",", "").replace(".", ","), ",", ".", 2));
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const imprimirNotaEntregaDebito = (ope, data) => (e) => {
    e.preventDefault();

    if (data.tipo === 'NE') {
      if (accbtnnentrega && accbtnnentrega.toString().substring(4, 5) === "1") {

        if (ope === 1) {

          let idnot = data.idfactura;

          let nota = JSON.parse(sessionStorage.getItem("tiporepnotaentrega"));
          var reporte = nota.toString() === 'HOJA' ? "ReportNotaEntrega" : "ReportNotaEntregaMedium";

          window.open(
            op.reportes +
            "/ventas?afiliado=" +
            afiliado +
            "&reporte=" +
            reporte +
            "&idnota=" +
            idnot,
            "Planilla",
            "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
          );
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡ Seleccione la nota de Entrega y/o Debito !",
            icono: "informacion",
          });

        }

      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else {
      if (accbtnndebito && accbtnndebito.toString().substring(4, 5) === "1") {

        if (ope === 1) {

          let idnot = data.numfactura;

          var reporte = "ReportNotaDebito";

          window.open(
            op.reportes +
            "/ventas?afiliado=" +
            afiliado +
            "&reporte=" +
            reporte +
            "&idnota=" +
            "'" + idnot + "'",
            "Planilla",
            "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
          );
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡ Seleccione la nota de Debito !",
            icono: "informacion",
          });
        }

      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    }

  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        if (props.op === 1) {
          seleccionarTotalesClientesPagosDetalle(0, props.client);
          setStatus(0);
          setIdclient(props.client);
          txtFocus.current.focus();
        } else if (props.op === 2) {
          seleccionarTotalesClientesPagosDetalle(1, props.client);
          setStatus(1);
          setIdclient(props.client);
          txtFocus.current.focus();
        } else {
          seleccionarTotalesClientesPagosDetalle('f.status', props.client);
          setStatus('n.status');
          setIdclient(props.client);
          txtFocus.current.focus();
        }

      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>{props.op === 1 ? 'Relación de Cuenta (Deudas)' : props.op === 3 ? 'Relación de Cuenta (General)' : 'Relación de Cuenta (Pagadas)'}</h3></div>

        <a href='#' ref={btnSalir} disabled={botones.salir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0'>

          <div className='col-md-12 row m-0'>
            <div className='col-md-12 px-0 mb-3'>
              <label className="input-group-text bg-trasnparent border-0 fs-4" id="inputGroup-sizing-sm">CLIENTE: {client} - RIF: {rifcliente}</label>
            </div>
          </div>

          <div className="col-md-12" style={{ marginBottom: "10px" }}>
            <div className="row m-0 px-0 col-7">
              <div className="input-group input-group-sm mb-1 px-0">
                <div className="input-group input-group-sm">
                  <label className="input-group-text border-azul" id="inputGroup-sizing-sm">BUSCAR:</label>
                  <input type="text" ref={txtFocus} className="form-control text-uppercase border-azul" onChange={handleSearch} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>
            </div>
          </div>

          <TblContainer >
            <TblHead />

            <TableBody>
              {
                records && recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow key={index}>
                    <TableCell className='py-2'><button onClick={imprimirNotaEntregaDebito(1, item)} className="btn btn-sm btn-info"><i className="fas fa-print"></i>{" "}</button></TableCell>
                    <TableCell className='py-2'>{item.numfactura}</TableCell>
                    <TableCell className='py-2'>{item.descripcionnota}</TableCell>
                    <TableCell className='py-2 text-center'>{moment(item.fecha).format('DD/MM/YYYY')}</TableCell>
                    <TableCell className='py-2 text-right'>{formatMoneda(item.totalmonto.toString().replace(",", "").replace(".", ","), ",", ".", 2)}</TableCell>
                    {props.op === 3 ? <TableCell className='py-2 text-center'>
                      {item.status === 0 ? <b className='fw-bold text-warning'>POR PAGAR</b> :
                        item.status === 1 ? <b className='fw-bold text-success'>PAGADA</b> :
                          <b className='fw-bold text-danger'>ANULADA</b>}
                    </TableCell> : ''}
                  </TableRow>

                ))
              }
            </TableBody>

          </TblContainer>
          <TblPagination />

          <div className='col-md-12 row m-0'>
            {props.op === 1 ? <div className='col-md-4'>
              <label className="input-group-text border-azul" id="inputGroup-sizing-sm">ANTICIPO SIN APLICAR: <p className='fs-5 text-right w-100'>{totalanticipos}</p></label>
            </div> : ''}

            {props.op === 1 ? <div className='col-md-4'>
              <label className="input-group-text border-azul" id="inputGroup-sizing-sm">CREDITO SIN APLICAR: <p className='fs-5 text-right w-100'>{totalcredito}</p></label>
            </div> : ''}

            <div className='col-md-4 ml-auto'>
              <label className="input-group-text border-azul" id="inputGroup-sizing-sm">{props.op === 1 ? 'TOTAL DEUDA:' : props.op === 3 ? 'MONTO TOTAL:' : 'TOTAL PAGADO:'} <p className='fs-5 text-right w-100'>{totaldeuda}</p></label>
            </div>
          </div>

        </div>
      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">

          <div className='col-md-4 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnAcepta} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-primary mx-1"><i className="fas fa-print">  Imprimir</i></button>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>

    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/ventas/modalEstadosdeCuentaClientes.js